// @flow
import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { translate } from 'react-i18next';

import Radio from 'common/domain/radio';
import Page from 'common/components/Page';
import { openSnackbar } from 'common/modules/ui/actions/uiActions';
import PropositionFilter, { ALL_FILTERS } from 'common/modules/proposition/components/PropositionFilter';
import FilterTableHeader from 'common/components/FilterTableHeader';
import Proposition from 'common/modules/proposition/domain/proposition';
import PropositionListing from 'common/modules/proposition/domain/propositionListing';
import { getUser } from 'statsradio/modules/authentication/session/selectors/sessionSelectors';
import SalesPropositionTable from './components/proposition/SalesPropositionTable';
import SalesPropositionApi from './services/SalesPropositionApi';

type Props = {
  user: Object,
  radio: Radio,
  token: string,

  actions: {
    openSnackbar: (kind: string, message: string) => any,
  },

  t: any,
  history: any,
};

type State = {
  fetchOptions: Object,

  isFetching: boolean,
  propositions: PropositionListing[],
};

class SalesPropositionPage extends Component<Props, State> {

  state = {
    fetchOptions: {
      filterBy: ALL_FILTERS,
      currentPage: 1,
      limit: 999999,
    },
    isFetching: false,
    propositions: [],
  };

  componentDidMount() {
    const { fetchOptions } = this.state;
    this.fetchPropositions(fetchOptions);
  }

  componentDidUpdate(prevProps: Props) {
    if (this.props.radio === prevProps.radio) {
      return;
    }

    const { fetchOptions } = this.state;
    this.fetchPropositions(fetchOptions);
  }

  fetchPropositions = (fetchOptions: Object) => {
    const { radio: { callSign }, token } = this.props;

    this.setState({ fetchOptions, isFetching: true });
    return SalesPropositionApi.fetchSalesPropositions(callSign, token, fetchOptions)
      .then(propositions => this.setState({ propositions, isFetching: false }))
      .catch(() => this.setState({ isFetching: false }));
  };

  onPropositionChange = (proposition: Proposition) => {
    const { propositions } = this.state;
    const modified = propositions.map((p) => {
      if (p.reference !== proposition.reference) {
        return p;
      }

      return PropositionListing.fromProposition(proposition);
    });

    this.setState({ propositions: modified });
  }

  render() {
    const { isFetching, propositions, fetchOptions } = this.state;
    const { user, t } = this.props;
    const menuItems = [
      { label: t('sortedBy'), value: undefined },
      { label: t('name'), value: 'NAME' },
      { label: t('broadcastDate'), value: 'START_DATE' },
      { label: t('propositionDate'), value: 'PROPOSED_DATE' },
    ];
    return (
      <Page title={t('propositions')}>
        <FilterTableHeader
          filterComponent={<PropositionFilter />}
          orderByItems={menuItems}
          options={fetchOptions}
          onOptionsChange={this.fetchPropositions}
        />
        <SalesPropositionTable
          user={user}
          propositions={propositions}
          loading={isFetching}
          onClick={proposition => this.props.history.push(`/proposition/${proposition.reference}`)}
          onChange={proposition => this.onPropositionChange(proposition)}
        />
      </Page>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: getUser(state),
    radio: state.session.radio,
    token: state.session.token,
  };
}

function mapDispatchToProps(dispatch: *) {
  return {
    actions: bindActionCreators({ openSnackbar }, dispatch),
  };
}

export default translate('sales')(connect(mapStateToProps, mapDispatchToProps)(withRouter(SalesPropositionPage)));



// WEBPACK FOOTER //
// ./src/statsradio/modules/sales/SalesPropositionPage.js